import { render, staticRenderFns } from "./sale.vue?vue&type=template&id=34e6b0e7&"
import script from "./sale.vue?vue&type=script&lang=ts&"
export * from "./sale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports